import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TreasuryApiResponse } from "../model/bank-account.model";
import { TreasuryRequirementBatchResponse } from "../model/payment-batch.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class TreasuryPaymentBatchesService {
  private readonly url: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) basePath: string,
  ) {
    this.url = `${basePath.replace(/\/$/, "")}/api/v1/payment-batches`;
  }

  listRequirementBatches(
    idRequirements: readonly number[],
  ): Observable<TreasuryApiResponse<TreasuryRequirementBatchResponse[]>> {
    const params = new HttpParams().set("idRequirements", idRequirements.join(","));
    return this.http.get<TreasuryApiResponse<TreasuryRequirementBatchResponse[]>>(
      `${this.url}/requirements`,
      { params },
    );
  }
}
